import React, { useState } from 'react';
import '../styles/TestAndDeploy.css';

interface Bot {
  id: string;
  name: string;
  url: string; // Default URL for the bot
}

const TestAndDeploy: React.FC = () => {
  const [bots] = useState<Bot[]>([
    // { id: '1', name: 'Bot Alpha', url: 'https://example.com/bot-alpha-default' },
    // { id: '2', name: 'Bot Beta', url: 'https://example.com/bot-beta-default' },
    // { id: '3', name: 'Bot Gamma', url: 'https://example.com/bot-gamma-default' },
  ]);
  const [selectedBot, setSelectedBot] = useState<Bot | null>(null);
  const [inputUrl, setInputUrl] = useState('');
  const [iframeUrl, setIframeUrl] = useState('');

  const handleSelectBot = (bot: Bot) => {
    setSelectedBot(bot);
    // Optionally, set a default URL for the selected bot or clear the input
    setInputUrl(bot.url); // Pre-fill input with bot's default URL
    setIframeUrl(bot.url); // Or immediately load the bot's default URL
  };

  const handleLoadUrl = () => {
    if (inputUrl.trim()) {
      setIframeUrl(inputUrl.trim());
    }
  };

  return (
    <div className="test-and-deploy-container">
      <div className="test-and-deploy-content">
        <div className="bot-selection-panel">
          <h2>Select a Bot</h2>
          <ul className="bot-list">
            {bots.map((bot) => (
              <li
                key={bot.id}
                className={`bot-list-item ${selectedBot?.id === bot.id ? 'selected' : ''}`}
                onClick={() => handleSelectBot(bot)}
              >
                {bot.name}
              </li>
            ))}
          </ul>
          <div className="url-input-section">
            <h3>Load Custom URL</h3>
            <input
              type="text"
              value={inputUrl}
              onChange={(e) => setInputUrl(e.target.value)}
              placeholder="Enter URL to test"
              className="url-input"
            />
            <button onClick={handleLoadUrl} className="load-url-button">
              Load URL in Iframe
            </button>
          </div>
        </div>
        <div className="iframe-display-panel">
          {iframeUrl ? (
            <iframe
              src={iframeUrl}
              title="Bot Test Environment"
              className="bot-iframe"
            />
          ) : (
            <div className="iframe-placeholder">
              <p>Select a bot or enter a URL to load it here.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TestAndDeploy;
